<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">退付手续费</li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
        v-if="$judge_auth('95')"
      >
        从税局更新数据
      </el-button>
      <el-button
        type="danger"
        link
        icon="Tickets"
        @click.stop="onCancel"
        v-if="$judge_auth('97')"
      >
        撤销申请
      </el-button>
      <el-button
        type="success"
        link
        icon="Tickets"
        @click.stop="onExport()"
        v-if="$judge_auth('98')"
      >
        导出
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click.stop="state.showLog = true"
        v-if="$judge_auth('99')"
      >
        操作记录
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-radio-group v-model="state.params.qrbszt" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button value="Y">已确认</el-radio-button>
        <el-radio-button value="N">未确认</el-radio-button>
      </el-radio-group>
      <c_statusradiogroup
        v-model="state.params.sqztdm"
        arrName="ptscommission_sqzt"
        @change="onLoad"
      ></c_statusradiogroup>
      <c_withholdingagentselect
        @confirm="(ids) => (state.params.withholding_agent_id = ids)"
      ></c_withholdingagentselect>
      <el-select
        v-model="state.params.tax_bureau_id"
        placeholder="税局"
        style="width: 320px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="update_time"
          label="更新时间"
          width="120"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="jbdxh"
          label="结报单序号"
          :formatter="$tab_TextFormat"
          :min-width="120"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          label="申请状态"
          :formatter="$tab_TextFormat"
          :width="140"
        >
          <template #default="{ row }">
            <c_status arrName="ptscommission_sqzt" :value="row.sqztdm" />
          </template>
        </el-table-column>
        <el-table-column
          prop="qrbszt"
          label="确认状态"
          :formatter="$tab_TextFormat"
          :width="100"
        >
          <template #default="{ row }">
            <text :style="{ color: row.qrbszt === 'Y' ? '#1e90ff' : '#f00' }">
              {{ row.qrbszt === "Y" ? "已确认" : "未确认" }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="sqtfje"
          label="申请退付金额"
          :formatter="$tab_PriceFormat"
          :width="140"
        />
        <el-table-column
          prop="tfsxfje"
          label="实缴(退)金额"
          :formatter="$tab_PriceFormat"
          :width="140"
        />
        <el-table-column
          prop="yhmc"
          label="银行名称"
          :formatter="$tab_TextFormat"
          :width="120"
        />
        <el-table-column
          prop="yhwdmc"
          label="开户行"
          :formatter="$tab_TextFormat"
          :min-width="140"
        />
        <el-table-column
          prop="yhzh"
          label="账号"
          :formatter="$tab_TextFormat"
          :min-width="140"
        />
        <el-table-column
          prop="yhzhmc"
          label="户名"
          :formatter="$tab_TextFormat"
          :width="120"
        />
        <el-table-column label="操作" width="340" align="center" fixed="right">
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click.stop="
                state.selectItem = row;
                state.showHdqc = true;
              "
              v-if="$judge_auth('100')"
            >
              单户核对清册
            </el-button>
            <el-button
              type="success"
              link
              icon="Select"
              @click.stop="
                state.selectItem = row;
                state.showXzyh = true;
              "
              :disabled="row.status === 0"
              v-if="$judge_auth('95')"
            >
              核对无误
            </el-button>
            <el-button
              type="danger"
              link
              icon="Close"
              @click.stop="onCancelSingle(row)"
              :disabled="row.sqztdm == '04'"
              v-if="$judge_auth('97')"
            >
              撤销申请
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新数据"
        @close="state.showAgent = false"
      >
        <c_Agent
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showXzyh"
        title="退付账户申请"
        @close="state.showXzyh = false"
      >
        <c_PtsCommissionYhzh
          v-if="state.showXzyh"
          :id="state.selectItem.id"
          :withholding_agent_id="state.selectItem.withholding_agent_id"
          @close="state.showXzyh = false"
        ></c_PtsCommissionYhzh>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showHdqc"
        :title="`来自${state.selectItem?.qymc}的核对清册`"
        @close="state.showHdqc = false"
      >
        <c_PtsCommissionHdqc
          v-if="state.showHdqc"
          @close="state.showHdqc = false"
          :id="state.selectItem?.id"
        ></c_PtsCommissionHdqc>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_PtsCommissionLog></c_PtsCommissionLog>
    </el-drawer>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_customer_select, data_taxbureau_select } from "@/http/data";
import { ptscommission_list, ptscommission_export } from "@/http/ptscommission";
import { ptscommission_cancel } from "@/http/ptscommission";
import { ElMessage, ElMessageBox } from "element-plus";

import c_Agent from "./SelectWithholdingAgent.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
  };
}
export default {
  components: {
    c_Agent,
  },
  setup() {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoadTaxBureau();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      ptscommission_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //从税局更新数据确认事件
    const onSelectConfirm = () => {
      state.showAgent = false;
      onLoad();
    };

    //单个撤销
    const onCancelSingle = (row) => {
      ElMessageBox.confirm(`您确定撤销该条退付申请吗？`, "撤销确认", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const data = {
          id: row.id,
        };
        ptscommission_cancel(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //批量撤销
    const onCancel = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定撤销已选<strong style='color:#1e90ff'>${rows.length}条</strong>条记录的退付申请吗？`,
        "撤销确认",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        const data = {
          id: rows.map((m) => m.id).join(","),
        };
        ptscommission_cancel(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onExport = () => {
      ptscommission_export(state.params)
        .then((res) => {
          if (res.status == 200) {
            let fileName = decodeURI(
              res.headers["content-disposition"].split("=")[1]
            );

            //通过后台返回 的word文件流设置文件名并下载
            var blob = new Blob([res.data], {
              type: res.data.type,
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          }
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadTaxBureau,
      onRowClick,
      onSelectConfirm,
      onCancelSingle,
      onCancel,
      onExport,
    };
  },
};
</script>
<style scoped></style>
